import React from "react";
import { IconProps } from "./props";

export const FuelIcon: React.FC<IconProps> = ({
  size = 24,
  fill = "#000000",
  strokeWidth = 1,
  strokeColor = "#000000",
  className = "",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 512 512"
      width={size}
      height={size}
      fill={fill}
      className={className}
    >
      <g>
        <g>
          <g>
            <path
              d="M309.333,53.333h-192c-5.867,0-10.667,4.8-10.667,10.667v138.667c0,5.867,4.8,10.667,10.667,10.667h192c5.867,0,10.667-4.8,10.667-10.667V64C320,58.133,315.2,53.333,309.333,53.333z M298.667,192H128V74.667h170.667V192z"
              stroke={strokeColor}
              strokeWidth={strokeWidth}
            />
            <path
              d="M394.667,490.667H32c-5.867,0-10.667,4.8-10.667,10.667C21.333,507.2,26.133,512,32,512h362.667c5.867,0,10.667-4.8,10.667-10.667C405.333,495.467,400.533,490.667,394.667,490.667z"
              stroke={strokeColor}
              strokeWidth={strokeWidth}
            />
            <path
              d="M474.133,124.907l-32.64-37.653c-1.28-1.493-3.093-2.347-5.013-2.24c-11.627,0.213-15.147,11.627-9.6,18.027l31.04,35.84c7.253,8.32,11.413,13.44,11.413,21.12h-29.867c-7.04,0-12.8,5.76-12.8,12.8V224c0,11.733,9.6,21.333,21.333,21.333h21.333v160c0,5.867-4.8,10.667-10.667,10.667h-23.573c-6.187,0-8.427-5.76-8.427-10.667v-139.2c0-18.773-17.707-31.467-34.24-31.467h-19.093V53.333C373.333,23.893,349.44,0,320,0H106.667c-29.44,0-53.333,23.893-53.333,53.333v415.253c0,10.773,8.64,10.88,23.04,11.2c7.787,0.107,18.56,0.213,30.293,0.213H320c11.84,0,22.507-0.107,30.293-0.213c14.4-0.213,23.04-0.427,23.04-11.2V256h19.093c6.507,0,12.907,5.013,12.907,10.133v139.2c0,18.24,12.8,32,29.76,32h23.573c17.707,0,32-14.293,32-32V160C490.667,144,481.92,133.867,474.133,124.907z M352,458.453c-7.04,0.107-17.813,0.213-32,0.213H106.667c-14.187,0-24.96-0.107-32-0.213V53.333c0-17.707,14.293-32,32-32H320c17.707,0,32,14.293,32,32V458.453z M469.333,224H448v-42.667h21.333V224z"
              stroke={strokeColor}
              strokeWidth={strokeWidth}
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
